<template>
    <div id="list-boiler-equipment-component" class="pa-4">
        <in-progress-component/>
    </div>
</template>

<script>
import InProgressComponent from "@/components/Error/InProgressComponent";

export default {
    name: "ListBoilerEquipmentComponent",
    components: {InProgressComponent}
}
</script>